/**
 * Before you edit these, read the documentation on how these files are compiled:
 * https://docs.phpvms.net/developers/building-assets
 *
 * Edits here don't take place until you compile these assets and then upload them.
 * Available providers: https://leaflet-extras.github.io/leaflet-providers/preview/
 */

const leaflet = require('leaflet');
require('leaflet-providers');

// CARTO's current raster endpoint requires an API key.
const cartoProvider = leaflet.TileLayer.Provider.providers.CartoDB;
cartoProvider.url = 'https://basemaps.cartocdn.com/rastertiles/{variant}/{z}/{x}/{y}.png?key={key}';
cartoProvider.options = Object.assign({}, cartoProvider.options, {
  attribution: '{attribution.OpenStreetMap} &copy; <a href="https://carto.com/attributions">CARTO</a>',
});

leaflet.TileLayer.Provider.providers.Jawg = {
  url: 'https://tile.jawg.io/{variant}/{z}/{x}/{y}{r}.png?access-token={accessToken}',
  options: {
    attribution: '<a href="https://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank">&copy; <b>Jawg</b>Maps</a> {attribution.OpenStreetMap}',
    minZoom: 0,
    maxZoom: 22,
    variant: 'jawg-dark',
  },
  variants: {
    Dark: 'jawg-dark',
    Light: 'jawg-light',
  },
};

const getJawgProvider = () => {
  const storedDataTheme = localStorage.getItem('data-bs-theme');
  const storedTheme = localStorage.getItem('theme');
  let theme = document.documentElement.getAttribute('data-bs-theme');

  if (storedDataTheme === 'dark' || storedDataTheme === 'light') {
    theme = storedDataTheme;
  } else if (storedTheme === 'dark' || storedTheme === 'light') {
    theme = storedTheme;
  }

  return theme === 'dark' ? 'Jawg.Dark' : 'Jawg.Light';
};

export const create_jawg_layer = (options = {}) => {
  const layerGroup = leaflet.layerGroup();
  let currentLayer = null;
  let currentProvider = null;
  let observer = null;

  const updateLayer = () => {
    const provider = getJawgProvider();
    if (provider === currentProvider) {
      return;
    }

    if (currentLayer !== null) {
      layerGroup.removeLayer(currentLayer);
    }

    currentLayer = leaflet.tileLayer.provider(provider, options);
    currentProvider = provider;
    layerGroup.addLayer(currentLayer);
  };

  layerGroup.on('add', () => {
    updateLayer();
    observer = new MutationObserver(updateLayer);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme'],
    });
  });

  layerGroup.on('remove', () => {
    if (observer !== null) {
      observer.disconnect();
      observer = null;
    }
  });

  return layerGroup;
};

export const get_jawg_provider = getJawgProvider;

export default (_opts) => {
  const opts = Object.assign({
    render_elem: 'map',
    center: [29.98139, -95.33374],
    zoom: 5,
    maxZoom: 10,
    layers: [],
    set_marker: false,
    leafletOptions: {},
  }, _opts);

  const leafletOptions = Object.assign({
    center: opts.center,
    zoom: opts.zoom,
    scrollWheelZoom: false,
    providers: {},
  }, opts.leafletOptions);

  // Check if any providers are listed; if not, set the default
  if (Object.entries(leafletOptions.providers).length === 0) {
    leafletOptions.providers = {
      'Esri.WorldStreetMap': {},
    };
  }

  const map = leaflet.map('map', leafletOptions);

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in leafletOptions.providers) {
    const layer = key.indexOf('Jawg.') === 0
      ? create_jawg_layer(leafletOptions.providers[key])
      : leaflet.tileLayer.provider(key, leafletOptions.providers[key]);

    layer.addTo(map);
  }

  return map;
};
